<script lang="ts">
  import app from '#app/app'
  import { currentRoute } from '#app/lib/location'
  import Modal from '#components/modal.svelte'
  import ItemShow from '#inventory/components/item_show.svelte'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'

  let {
    item = $bindable(),
    showItemModal = $bindable(),
    onClosingModal,
  }: {
    item: SerializedItemWithUserData
    showItemModal?: boolean
    onClosingModal?: () => void
  } = $props()

  const pathnameBeforeModal = currentRoute()

  function closeItemModalAndFallback () {
    app.navigate(pathnameBeforeModal, { preventScrollTop: true })
    closeItemModal()
  }

  function closeItemModal () {
    showItemModal = false
    onClosingModal?.()
  }
</script>

{#if showItemModal}
  <Modal size="large" onCloseModal={closeItemModalAndFallback}>
    <ItemShow
      bind:item
      onNavigate={closeItemModal}
    />
  </Modal>
{/if}
